import { msiRequest } from "../../../index";
import { ResultType } from "../../../types";
import qs from 'qs'
//接口url枚举
enum StatisticalEnumApi{
  CHECK_PLAN_PAGE = '/check/plan/query', //盘点计划
  CHECK_PLAN_ADD = '/check/plan/add',
  CHECK_PLAN_EDIT = '/check/plan/edit',
  CHECK_PLAN_DELETE = '/check/plan/delete',
  CHECK_PLAN_ORDER = '/check/plan/id',
  CHECK_PLAN_DETAIL = '/check/plan/detail/query',
  CHECK_PLAN_REJECT = '/check/plan/reject',
  CHECK_PLAN_PASS = '/check/plan/pass',
  CHECK_MATERIAL_LIST = '/inventory/material/query',
  CHECK_PLAN_RANGE = '/check/plan/range/query',

}
//盘点计划 --- 计划范围
export function getCheckPlanRange(data: any = {}) {
  return msiRequest.get<ResultType<any>>({
    url: `${StatisticalEnumApi.CHECK_PLAN_RANGE}?${qs.stringify(data)}`,
    data
  })
}

//盘点计划 --- 计划明细查询
export function getCheckPlanDetail(data: any = {}) {
  return msiRequest.get<ResultType<any>>({
    url: `${StatisticalEnumApi.CHECK_PLAN_DETAIL}?${qs.stringify(data)}`,
    data
  })
}

//盘点计划 --- 列表
export function getCheckPlanPage(data: any = {}) {
  return msiRequest.get<ResultType<any>>({
    url: `${StatisticalEnumApi.CHECK_PLAN_PAGE}?${qs.stringify(data)}`,
    data
  })
}

//盘点计划 -- 计划号
export function getCheckPlanOrder() {
  return msiRequest.get<ResultType<any>>({
    url: StatisticalEnumApi.CHECK_PLAN_ORDER
  })
}

//盘点计划 -- 添加
export function addCheckPlan(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
      url: `${StatisticalEnumApi.CHECK_PLAN_ADD}`,
      data
    })
}

//盘点计划 -- 编辑
export function editCheckPlan(data: any = {}) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.CHECK_PLAN_EDIT,
    data
  })
}

//盘点计划 -- 删除
export function deleteCheckPlan(data: {OrderNo: string}) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.CHECK_PLAN_DELETE,
    data
  })
}

//盘点计划驳回
export function rejectCheckPlan(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: StatisticalEnumApi.CHECK_PLAN_REJECT,
        data
    })
}

//盘点计划通过
export function passCheckPlan(data: {OrderNo: string}) {
    return msiRequest.post<ResultType<any>>({
        url: StatisticalEnumApi.CHECK_PLAN_PASS,
        data
    })
}

//获取所有批次的物料
export function getMaterialPage(data: any={}) {
  return msiRequest.get<ResultType<any>>({
    url: `${StatisticalEnumApi.CHECK_MATERIAL_LIST}?${qs.stringify(data)}`,
    data
  }) 
}
